import { render, staticRenderFns } from "./ChatVenue.vue?vue&type=template&id=3fbb272b&scoped=true"
import script from "./ChatVenue.vue?vue&type=script&lang=ts"
export * from "./ChatVenue.vue?vue&type=script&lang=ts"
import style0 from "./ChatVenue.vue?vue&type=style&index=0&id=3fbb272b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb272b",
  null
  
)

export default component.exports